// Alertes de surveillance de l'agent (serveurs d'IA, campagne sans progrès, échecs en série) : relues toutes les
// 2 minutes ; elles disparaissent d'elles-mêmes quand le problème est réglé. Rien n'est affiché sans alerte.
import React from 'react';
import { Box, Typography } from '@mui/material';
import { AxiosInstanceCreator } from '../../../api/AxiosInstance';
import { autopilotApiUrl } from '../services/autopilotRunApi';
import { FONT, NEUTRAL } from '../../shared/ui';

export interface AgentAlert { key: string; level: 'attention' | 'critique'; title: string; detail: string; campaign_id?: string | null }

export const loadAgentAlerts = async (): Promise<AgentAlert[]> => {
    if (!autopilotApiUrl()) return [];
    try {
        return ((await AxiosInstanceCreator(autopilotApiUrl(), 'autopilot').get('alerts')).data?.items || []) as AgentAlert[];
    } catch {
        return [];
    }
};

const POLL_MS = 120_000;

const AgentAlerts: React.FC<{ load?: typeof loadAgentAlerts }> = ({ load = loadAgentAlerts }) => {
    const [alerts, setAlerts] = React.useState<AgentAlert[]>([]);
    React.useEffect(() => {
        let alive = true;
        const read = () => load().then((a) => { if (alive) setAlerts(a); });
        read();
        const id = window.setInterval(read, POLL_MS);
        return () => { alive = false; window.clearInterval(id); };
    }, [load]);
    if (!alerts.length) return null;
    return (
        <Box data-testid="agent-alerts" sx={{ mt: 1.75, display: 'grid', gap: 1 }}>
            {alerts.map((a) => {
                const critical = a.level === 'critique';
                return (
                    <Box key={a.key} data-testid="agent-alert" sx={{ px: 2, py: 1.25, borderRadius: '10px',
                        backgroundColor: critical ? 'rgba(194,65,12,0.10)' : 'rgba(201,138,11,0.10)',
                        border: `1px solid ${critical ? 'rgba(194,65,12,0.35)' : 'rgba(201,138,11,0.35)'}` }}>
                        <Typography sx={{ fontSize: 13, fontWeight: 600, color: critical ? NEUTRAL.danger : NEUTRAL.text, fontFamily: FONT }}>
                            {a.title}
                        </Typography>
                        {a.detail && (
                            <Typography sx={{ fontSize: 12.5, color: NEUTRAL.muted, fontFamily: FONT }}>{a.detail}</Typography>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default AgentAlerts;
